import { render } from "./purchase-orders.vue?vue&type=template&id=b87ba710&scoped=true"
import script from "./purchase-orders.vue?vue&type=script&lang=js"
export * from "./purchase-orders.vue?vue&type=script&lang=js"

import "./purchase-orders.vue?vue&type=style&index=0&id=b87ba710&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87ba710"]])

export default __exports__